import Vue from 'vue';
export default Vue.extend({
    name: 'confirmWhitelistRepeat',
    props: {
        slotData: {
            required: true
        }
    }
});
